import Loading from '../../../../Dashboards/Common/Loading';
import { ExternalWallMeterial } from './ExternalWallMeterial';
import { HouseSideWalk } from './HouseSideWalk';
import { Lighting } from './Lighting';
import { PavementType } from './PavementType';
import { useInfrastructureChartsDataContext } from './hooks/useInfrastructureChartsDataContext';

export const Charts = () => {
    const { isLoading } = useInfrastructureChartsDataContext();

    if (isLoading ) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards" >
                <PavementType/>
                <Lighting/>
            </div>
            <div className="charts-side-by-side-dashboards">
                <ExternalWallMeterial/>
                <HouseSideWalk/>
            </div>
        </>
    );
};
